import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosLLInstance from "../../utils/axiosLLInstance";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbItems from "../../components/BreadcrumbItems";
import { AutoComplete, Input } from "antd";
import Devices from "../common/DevicesTable";
import { SearchOutlined } from "@ant-design/icons";
import { SET_SELECTED_DEVICE } from "../../redux/actions/dashboardActions";
import { notifyUser } from "../../utils/notifyUser";
import { search } from "../Dashboard/icons";

export default function UserDevices() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId, fleetId } = useParams();
  const fleetUser = useSelector((state) => state.users.fleetUser);
  const [searchQuery, setSearchQuery] = useState("");
  const [lastQuery, setLastQuery] = useState("");
  const [options, setOptions] = useState([]);

  const onSelect = (device) => {
    const selectedDevice = JSON.parse(device);
    dispatch(SET_SELECTED_DEVICE(selectedDevice));
    navigate(`/dashboard/devices-analytics/${selectedDevice.imei}`);
  };

  const handleSearch = () => {
    if (searchQuery.trim() !== lastQuery) {
      setLastQuery(searchQuery.trim());
      searchDevice(searchQuery);
    }
  };

  const handleChange = (value) => {
    if (!value.trim()) {
      setOptions([]);
      setLastQuery("");
      setSearchQuery("");
    }
    setSearchQuery(value);
  };

  const searchDevice = async (value) => {
    if (!value.trim()) {
      return;
    }
    try {
      const { data } = await axiosLLInstance.get(
        "/devices/search_within_fleet",
        {
          params: { id: fleetId, imei: value },
        }
      );
      if (!data.length) {
        notifyUser({
          message: "No Match Found",
          type: "warning",
        });
        setOptions([]);
        return;
      }
      const options = data.map((device) => ({
        label: device.imei,
        value: JSON.stringify(device),
      }));
      setOptions?.(options);
    } catch (error) {
      console.error("Error fetching devices", error);
    }
  };
  return (
    <>
      <div className="flex items-center justify-between">
        <BreadcrumbItems
          items={[
            { title: `Manage Users`, to: `/users` },
            { title: "fleet", to: `/users/${userId}/fleets` },
            { title: "Devices" },
          ]}
        />
        <div className="search-adminBox flex items-center justify-between w-32rem]">
          <AutoComplete
            className="h-12 border-gray-200 hover:border-gray-200 focus:border-gray-200 focus-within:border-gray-200 focus-within:shadow-none"
            onChange={handleChange}
            options={options}
            onSelect={onSelect}
          >
            <Input
              size="large"
              className="h-12 border-gray-200 hover:border-gray-200 focus:border-gray-200 focus-within:border-gray-200 focus-within:shadow-none"
              placeholder="Search IMEI"
              prefix={
                <img src={search} alt="search icon" onClick={handleSearch} />
              }
            />
          </AutoComplete>
        </div>
      </div>
      <div className="mt-12">
        <Devices fleetId={fleetId} userId={fleetUser ? fleetUser.id : null} />
      </div>
    </>
  );
}
